import { useQuery } from "@tanstack/react-query";
import { getMachineOfStoreApiRequest } from "../../services";
import { useAccountOfStore } from "../../store";

export const useGetMachineOfStoreApi = () => {
  const { storeId } = useAccountOfStore();
  const { data, isLoading } = useQuery({
    queryKey: ["all-machine-of-store", storeId],
    queryFn: () => getMachineOfStoreApiRequest(storeId),
    enabled: true,
  });
  return {
    machineOfStore: data,
    isLoading,
  };
};
